module.exports = __webpack_public_path__ + "img/avatar-5.962f01d0.png";